import React from 'react';

const InstagramConnect = () => {
  return (
    <section className="w-full py-4">
      <div className="grid grid-cols-3 md:grid-cols-5 gap-2 md:gap-4">
        {/* First Image */}
        <a href="https://www.instagram.com/leafwellfarm" target='_blank' rel='noreferrer' className="rounded-xl overflow-hidden link-instagram">
          <img src="/images/Home/instagram/instagram_img1.jpg" alt="" className="w-full" />
          <div className="icon-instagram">
            <div className='wrapper-icon-circle'>
              <img src="/icons/instagram.svg" alt="" />
            </div>
          </div>
        </a>

        {/* Second Image */}
        <a href="https://www.instagram.com/leafwellfarm" target='_blank' rel='noreferrer' className="rounded-xl overflow-hidden link-instagram">
          <img src="/images/Home/instagram/instagram_img2.jpg" alt="" className="w-full" />
          <div className="icon-instagram">
            <div className='wrapper-icon-circle'>
              <img src="/icons/instagram.svg" alt="" />
            </div>
          </div>
        </a>

        {/* Third Image */}
        <a href="https://www.instagram.com/leafwellfarm" target='_blank' rel='noreferrer' className="rounded-xl overflow-hidden link-instagram">
          <img src="/images/Home/instagram/instagram_img3.jpg" alt="" className="w-full" />
          <div className="icon-instagram">
            <div className='wrapper-icon-circle'>
              <img src="/icons/instagram.svg" alt="" />
            </div>
          </div>
        </a>

        {/* Fourth Image */}
        <a href="https://www.instagram.com/leafwellfarm" target='_blank' rel='noreferrer' className="rounded-xl overflow-hidden link-instagram link-instagramm">
          <img src="/images/Home/instagram/instagram_img1.jpg" alt="" className="w-full" />
          <div className="icon-instagram">
            <div className='wrapper-icon-circle'>
              <img src="/icons/instagram.svg" alt="" />
            </div>
          </div>
        </a>

        {/* Fifth Image */}
        <a href="https://www.instagram.com/leafwellfarm" target='_blank' rel='noreferrer' className="rounded-xl overflow-hidden link-instagram link-instagramm">
          <img src="/images/Home/instagram/instagram_img3.jpg" alt="" className="w-full" />
          <div className="icon-instagram">
            <div className='wrapper-icon-circle'>
              <img src="/icons/instagram.svg" alt="" />
            </div>
          </div>
        </a>

      </div>
    </section>
  );
};

export default InstagramConnect;
